// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1010":"1d67d3acaa42aa31","5707":"1d67d3acaa42aa31"}[chunkId] + ".css";
};